/* RESPONSIBLE TEAM: team-automation-foundations */
import ContentEditorRoute from 'embercom/routes/apps/app/content/edit';
import { inject as service } from '@ember/service';

export default ContentEditorRoute.extend({
  router: service(),

  redirect(model) {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.profiles.edit', model.id);
  },
});
